'use strict';
var inputs = document.querySelectorAll('form input');
function capitalize(text) {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
}
inputs.forEach(function(input) {
    var inputName = input.name;
    var inputId = input.id;
    var formattedName = capitalize(inputName);
    var label = document.createElement('label');
    label.classList.add('field-label');
    label.htmlFor = inputId;
    label.textContent = formattedName;
    input.placeholder = formattedName;
    var parentContainer = input.parentElement;
    parentContainer.prepend(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.42c7346d.js.map
